import React, { Component } from 'react';
import { withTheme, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';

// ui/ux
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

// icons
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

const styles = (/* theme */) => ({
  title: {
    zIndex: 2,
    mixBlendMode: 'difference',
    color: 'red',
    position: 'absolute',
    bottom: 0
  },
  container: {
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    position: 'relative'
  }
});

class ErrorSign extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { height, width, classes, variant } = this.props;
    let icon = <NotInterestedIcon />;
    let message = 'Oops, it broke.';
    if (variant === 'nodata') {
      icon = <RemoveCircleIcon />;
      message = 'Oops, no data available';
    }
    return (
      <Box
        className={classes.container}
        display="flex"
        style={{
          height,
          width,
          backgroundImage: `url('data:image/svg+xml;utf8,${renderToString(icon)}')`.replace(/class="[-\w]+"/, 'xmlns="http://www.w3.org/2000/svg" fill="red" stroke="red"')
        }}
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h3" className={classes.title}>
          {message}
        </Typography>
      </Box>
    );
  }
}

ErrorSign.propTypes = {
  classes: PropTypes.object,
  theme: PropTypes.object.isRequired,

  message: PropTypes.string,
  variant: PropTypes.string,

  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

ErrorSign.defaultProps = {
  width: '100%',
  height: '100%'
};

export default withTheme(withStyles(styles)(ErrorSign));
